export enum EExactFarmingProductId {
  poleDiff = 'ef_diff',
  poleExpert = 'ef_expert',
  poleScouting = 'ef_scout',
  polePlus = 'ef_plus',
  farmlandCropValuation = 'soil_landscape_survey',
}
